<template>
  <form
    id="contactForm1"
    class="margin-top"
    method="POST"
    action="/dashboard/contact-customer-care"
  >
    <!-- @submit.prevent="onSubmit" -->
    <input type="hidden" name="_token" :value="csrf" />
    <div class="form-item">
      <h3 id="sub_text">Fill Out The Form Below</h3>
      <p class="help-block">* Required Fields</p>
    </div>
    <!-- <div class="form-group">group name, phone, email  -->
    <div class="form-item half-width">
      <label for="first_name">First Name *</label>
      <input
        type="text"
        id="first_name"
        name="first_name"
        class="control-label required"
        required
        v-model="firstName"
      />
    </div>
    <div class="form-item half-width">
      <label for="last_name">Last Name *</label>
      <input
        type="text"
        id="last_name"
        name="last_name"
        class="control-label required"
        v-model="lastName"
        required
      />
    </div>
    <div class="form-item half-width">
      <label for="email">Email *</label>
      <input
        type="email"
        id="email"
        name="email"
        class="control-label required"
        required
        v-model="emailAddress"
        @input="validateEmail"
      />
      <span class="help-block" v-if="messages.email">{{ messages.email }}</span>
    </div>
    <div class="form-item half-width">
      <label for="phone">Phone</label>
      <input
        type="text"
        id="phone"
        name="phone"
        class="form-control"
        v-model="phoneNumber"
        @input="validatePhone"
      />
      <span class="help-block" v-if="messages.phone">{{ messages.phone }}</span>
    </div>
    <!-- </div> end name, phone, email grouping -->

    <div class="form-item">
      <label for="how_did_you_hear_about_itr_economics_">
        How did you hear about ITR Economics? *
      </label>
      <select
        id="how_did_you_hear_about_itr_economics_"
        class="control-label required"
        name="how_did_you_hear_about_itr_economics_"
        v-model="how_did_you_hear_about_itr_economics_"
        required
      >
        <option
          v-for="(opt, index) in how_did_you_hear_about_itr_economics_options"
          v-bind:key="index"
        >
          {{ opt }}
        </option>
      </select>
    </div>
    <div
      v-if="how_did_you_hear_about_itr_economics_ === 'Speaking engagement'"
      class="form-item"
    >
      <label for="speaker_lead">Speaker Lead</label>
      <select
        id="speaker_lead"
        class="control-label"
        name="speaker_lead"
        v-model="speaker_lead"
      >
        <option
          v-for="(speaker, index) in speaker_lead_options"
          v-bind:key="index"
        >
          {{ speaker }}
        </option>
      </select>
    </div>
    <div
      v-else-if="how_did_you_hear_about_itr_economics_ === 'Business referral'"
      class="form-item"
    >
      <label for="please_share_who_referred_you_to_itr_economics_">
        Please share who referred you to ITR Economics:
      </label>
      <input
        type="text"
        id="please_share_who_referred_you_to_itr_economics_"
        name="please_share_who_referred_you_to_itr_economics_"
        class="control-label required"
        v-model="please_share_who_referred_you_to_itr_economics_"
      />
    </div>
    <div
      v-else-if="how_did_you_hear_about_itr_economics_ === 'Other'"
      class="form-item"
    >
      <label for="please_elaborate_how_you_found_itr_economics_">
        Please elaborate how you found ITR Economics:
      </label>
      <textarea
        id="please_elaborate_how_you_found_itr_economics_"
        rows="5"
        name="please_elaborate_how_you_found_itr_economics_"
        class="form-control"
        v-model="please_elaborate_how_you_found_itr_economics_"
      ></textarea>
    </div>
    <div class="form-item">
      <label for="message">Message *</label>
      <textarea
        id="message"
        rows="5"
        name="message"
        class="form-control required"
        v-model="message"
        required
      ></textarea>
    </div>
    <!-- <div class="form-item">
            <label for="address">Address</label>
            <input type="text"
                id="address"
                class="form-control"
                v-model="address">
        </div> -->
    <div class="form-item">
      <div id="sub_text2" class="form-control-static">
        ITR Economics is committed to protecting your privacy. We only use your
        personal information to administer your account and to provide the
        products and services you requested from us. Occasionally we would like
        to contact you about our products and services. If you consent to us
        contacting you for this purpose, please tick below to say how you would
        like us to contact you:
      </div>
    </div>

    <div class="form-item">
      <label for="agreement">
        <input
          type="checkbox"
          id="agreement"
          name="agreement"
          v-model="agreement"
        />
        <p class="help-block">
          I agree to receive other communications from ITR Economics.
        </p>
      </label>
    </div>
    <div class="form-item">
      <div id="sub_text3" class="form-control-static">
        You can unsubscribe from these communications at any time. For more
        information on how to unsubscribe, our privacy practices, and how we are
        committed to protecting and respecting your privacy, please review our
        <b><a href="/privacy-policy">Privacy Policy</a></b>
        .
      </div>
    </div>
    <div class="form-item">
      <div id="sub_text4" class="form-control-static">
        By clicking submit below, you consent to allow ITR Economics to store
        and process the personal information submitted above to provide you the
        content requested.
      </div>
    </div>
    <button type="submit" class="button-green">Submit</button>
    <div class="form-response-message">{{ response_message }}</div>
  </form>
</template>

<script>
  export default {
    mount() {},
    props: {
      email: String,
      first_name: String,
      last_name: String,
      company: String,
      phone: String,
      address: String,
      country: String,
      postcode: String,
      recaptcha_key: String,
    },
    data: function () {
      return {
        csrf: document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
        recaptcha_error: false,
        how_did_you_hear_about_itr_economics_: '',
        how_did_you_hear_about_itr_economics_options: [
          'Speaking engagement',
          'Business referral',
          'Social media',
          'Internet search',
          'Other',
        ],
        speaker_lead: '',
        speaker_lead_options: [
          'Alan Beaulieu',
          'Brian Beaulieu',
          'Catherine Putney',
          'Connor Lokar',
          'Derek Stanley',
          'Jackie Greene',
          'Jeremy Bess',
          'Kyle Stevens',
          'Lauren Saidel-Baker',
          'Patrick Luce',
          'NA',
        ],
        please_share_who_referred_you_to_itr_economics_: '',
        please_elaborate_how_you_found_itr_economics_: '',
        // reason: '',
        // reason_options: ['Subscriptions', 'Consulting', 'Customized Reports', 'Speaking', 'Webinars', 'Books', 'Customer Care Support'],
        message: '',
        agreement: false,
        messages: [],
        regEmail:
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
        regPhone:
          /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
        response_message: '',
        errors: {},
        phoneNumber: '',
        emailAddress: '',
        firstName: '',
        lastName: '',
        companyName: '',
        addressValue: '',
        countryValue: '',
        postcodeValue: '',
      };
    },
    created() {
      this.phoneNumber = this.phone;
      this.emailAddress = this.email;
      this.firstName = this.first_name;
      this.lastName = this.last_name;
      this.companyName = this.company;
      this.addressValue = this.address;
      this.countryValue = this.country;
      this.postcodeValue = this.postcode;
    },
    methods: {
      onSubmit: function () {
        this.formSubmit();
      },
      onExpired: function () {
        this.recaptcha_error = true;
      },
      validateEmail() {
        if (!this.regEmail.test(this.email)) {
          this.messages['email'] = 'Please enter a valid email address';
        } else {
          this.messages['email'] = '';
        }
      },
      validatePhone() {
        if (!this.regPhone.test(this.phone)) {
          this.messages['phone'] =
            'Please enter a valid phone number (area code is needed)';
        } else {
          this.messages['phone'] = '';
        }
      },
      formSubmit() {
        var formData = {
          email: this.email,
          first_name: this.firstName,
          last_name: this.lastName,
          company: this.company,
          phone: this.phoneNumber,
          address: this.address,
          country: this.country,
          postcode: this.postcode,
          how_did_you_hear_about_itr_economics_:
            this.how_did_you_hear_about_itr_economics_,
          speaker_lead: this.speaker_lead,
          please_share_who_referred_you_to_itr_economics_:
            this.please_share_who_referred_you_to_itr_economics_,
          please_elaborate_how_you_found_itr_economics_:
            this.please_elaborate_how_you_found_itr_economics_,
          reason: this.reason,
          message: this.message,
          agreement: this.agreement,
        };

        if (this.messages.length === 0) {
          axios
            .post('/dashboard/contact-customer-care', formData)
            .then((response) => {
              this.response_message = response.data.message;
            })
            .catch((error) => {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors || {};
              }
            });
        }
      },
    },
  };
</script>
